import { Actions as EMPLOYEEACTIONS } from './employeeActions'

import apiURL from'./apiURL';

// types of action
const Types = {
  NOTE_VIEW_DETAIL: "NOTE_VIEW_DETAIL",
  NOTE_SAVING: "NOTE_SAVING",
  NOTE_SAVED: "NOTE_SAVED",
};

const showNoteDetail = ({show,item}) => ({
  type: Types.NOTE_VIEW_DETAIL,
  show,
  item,
});


const savingNote = () => ({
  type: Types.NOTE_SAVING,
});

const savedNote = (response) => ({
  type: Types.NOTE_SAVED,
  payload: response,
});

const saveNote = ({
  id,
	note,
	agreementId,
	notificationDate,
	showInPayroll,
}) => {
  return async (dispatch, getState) => {

    dispatch(savingNote())

    const state = getState();

    if (!agreementId){
      agreementId = state.employee?.agreementInfo?.id
    }

    fetch(apiURL + `/settings/note` , {
        credentials: 'include',
        method: 'POST',
        body:  JSON.stringify({
          id,
        	note,
        	agreementId,
    			notificationDate,
    			showInPayroll,
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(savedNote(data))
      dispatch(EMPLOYEEACTIONS.getEmployeeNotes({agreementId}))
    })


  }
}

const Actions = {
  showNoteDetail,
  saveNote
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions